// @ts-nocheck
import React from 'react';
import initialState from '/usr/src/app/src/.umi/plugin-initial-state/models/initialState';
import model0 from "/usr/src/app/src/models/albumanh";
import model1 from "/usr/src/app/src/models/baihoc";
import model2 from "/usr/src/app/src/models/baihocclone";
import model3 from "/usr/src/app/src/models/banghocphilop";
import model4 from "/usr/src/app/src/models/baocaonoibo";
import model5 from "/usr/src/app/src/models/baocaoquantri";
import model6 from "/usr/src/app/src/models/baocaosbn";
import model7 from "/usr/src/app/src/models/baohong";
import model8 from "/usr/src/app/src/models/camera";
import model9 from "/usr/src/app/src/models/cautraloi";
import model10 from "/usr/src/app/src/models/chiphidiemdanhmuon";
import model11 from "/usr/src/app/src/models/chucnangquantri";
import model12 from "/usr/src/app/src/models/chuongtrinhdaotao";
import model13 from "/usr/src/app/src/models/chuongtrinhdaotaoclone";
import model14 from "/usr/src/app/src/models/chuongtrinhkhung";
import model15 from "/usr/src/app/src/models/cloneMenu";
import model16 from "/usr/src/app/src/models/comment";
import model17 from "/usr/src/app/src/models/danhmucmonan";
import model18 from "/usr/src/app/src/models/danhmucmonanchung";
import model19 from "/usr/src/app/src/models/danhmuctaisan";
import model20 from "/usr/src/app/src/models/danhmucthucpham";
import model21 from "/usr/src/app/src/models/danhmucthucphamchung";
import model22 from "/usr/src/app/src/models/datagiaovien";
import model23 from "/usr/src/app/src/models/dataphuhuynh";
import model24 from "/usr/src/app/src/models/diemdanh";
import model25 from "/usr/src/app/src/models/diemdanhdaugio";
import model26 from "/usr/src/app/src/models/diemdanhgiaovien";
import model27 from "/usr/src/app/src/models/diemdanhhocsinh";
import model28 from "/usr/src/app/src/models/diemdanhmuon";
import model29 from "/usr/src/app/src/models/diemdanhphuhuynh";
import model30 from "/usr/src/app/src/models/diemdanhthubay";
import model31 from "/usr/src/app/src/models/doanhthu";
import model32 from "/usr/src/app/src/models/doanhthuthuc";
import model33 from "/usr/src/app/src/models/dondandonve";
import model34 from "/usr/src/app/src/models/dondanthuoc";
import model35 from "/usr/src/app/src/models/donvihanhchinh";
import model36 from "/usr/src/app/src/models/donxinnghi";
import model37 from "/usr/src/app/src/models/dotdanhgiasuckhoe";
import model38 from "/usr/src/app/src/models/dungluongalbums";
import model39 from "/usr/src/app/src/models/forgetPassword";
import model40 from "/usr/src/app/src/models/formdanhgia";
import model41 from "/usr/src/app/src/models/giamtru";
import model42 from "/usr/src/app/src/models/giaovien";
import model43 from "/usr/src/app/src/models/goithanhtoan";
import model44 from "/usr/src/app/src/models/hoadon";
import model45 from "/usr/src/app/src/models/hoatdongchung";
import model46 from "/usr/src/app/src/models/hoatdongngoaikhoa";
import model47 from "/usr/src/app/src/models/hocsinh";
import model48 from "/usr/src/app/src/models/khaibaothongtin";
import model49 from "/usr/src/app/src/models/khaosat";
import model50 from "/usr/src/app/src/models/khauphanan";
import model51 from "/usr/src/app/src/models/khoanchitieu";
import model52 from "/usr/src/app/src/models/khoanthu";
import model53 from "/usr/src/app/src/models/kyhoc";
import model54 from "/usr/src/app/src/models/lamthubay";
import model55 from "/usr/src/app/src/models/lichhoc";
import model56 from "/usr/src/app/src/models/lichhocanh";
import model57 from "/usr/src/app/src/models/lichsuthanhtoan";
import model58 from "/usr/src/app/src/models/loidancuaphuhuynh";
import model59 from "/usr/src/app/src/models/loptinchi";
import model60 from "/usr/src/app/src/models/maudanhgia";
import model61 from "/usr/src/app/src/models/monhoc";
import model62 from "/usr/src/app/src/models/monhocclone";
import model63 from "/usr/src/app/src/models/nhapkho";
import model64 from "/usr/src/app/src/models/nhapKhoNL";
import model65 from "/usr/src/app/src/models/quangcao";
import model66 from "/usr/src/app/src/models/quanlycauhinh";
import model67 from "/usr/src/app/src/models/quanlydanhgia";
import model68 from "/usr/src/app/src/models/quanlylop";
import model69 from "/usr/src/app/src/models/quydoi";
import model70 from "/usr/src/app/src/models/register";
import model71 from "/usr/src/app/src/models/sukien";
import model72 from "/usr/src/app/src/models/taikhoangiaovien";
import model73 from "/usr/src/app/src/models/taikhoanhieutruong";
import model74 from "/usr/src/app/src/models/taikhoankhach";
import model75 from "/usr/src/app/src/models/taikhoanphuhuynh";
import model76 from "/usr/src/app/src/models/templatelich";
import model77 from "/usr/src/app/src/models/thanhlytaisan";
import model78 from "/usr/src/app/src/models/thongbao";
import model79 from "/usr/src/app/src/models/thongkegiaovien";
import model80 from "/usr/src/app/src/models/thongkehocsinh";
import model81 from "/usr/src/app/src/models/thongkeluong";
import model82 from "/usr/src/app/src/models/thongtinchitiet";
import model83 from "/usr/src/app/src/models/thongtinhocphi";
import model84 from "/usr/src/app/src/models/thongtinhocphilop";
import model85 from "/usr/src/app/src/models/thongtinhocsinh";
import model86 from "/usr/src/app/src/models/thucdonanh";
import model87 from "/usr/src/app/src/models/thucdonmau";
import model88 from "/usr/src/app/src/models/thucdonmauchitiet";
import model89 from "/usr/src/app/src/models/thucphamkho";
import model90 from "/usr/src/app/src/models/tienthua";
import model91 from "/usr/src/app/src/models/tintucmamnon";
import model92 from "/usr/src/app/src/models/trangthaihocphi";
import model93 from "/usr/src/app/src/models/trongmuon";
import model94 from "/usr/src/app/src/models/trongmuonthang";
import model95 from "/usr/src/app/src/models/truong";
import model96 from "/usr/src/app/src/models/upload";
import model97 from "/usr/src/app/src/models/user";
import model98 from "/usr/src/app/src/models/vaitroquantri";
import model99 from "/usr/src/app/src/models/xemdsgiaovien";
import model100 from "/usr/src/app/src/models/xemdshocsinh";
import model101 from "/usr/src/app/src/models/xemdshocsinhtamnghi";
import model102 from "/usr/src/app/src/models/xuatbaocaothucpham";
import model103 from "/usr/src/app/src/models/xuatkho";
// @ts-ignore
import Dispatcher from './helpers/dispatcher';
// @ts-ignore
import Executor from './helpers/executor';
// @ts-ignore
import { UmiContext } from './helpers/constant';

export const models = { '@@initialState': initialState, 'albumanh': model0, 'baihoc': model1, 'baihocclone': model2, 'banghocphilop': model3, 'baocaonoibo': model4, 'baocaoquantri': model5, 'baocaosbn': model6, 'baohong': model7, 'camera': model8, 'cautraloi': model9, 'chiphidiemdanhmuon': model10, 'chucnangquantri': model11, 'chuongtrinhdaotao': model12, 'chuongtrinhdaotaoclone': model13, 'chuongtrinhkhung': model14, 'cloneMenu': model15, 'comment': model16, 'danhmucmonan': model17, 'danhmucmonanchung': model18, 'danhmuctaisan': model19, 'danhmucthucpham': model20, 'danhmucthucphamchung': model21, 'datagiaovien': model22, 'dataphuhuynh': model23, 'diemdanh': model24, 'diemdanhdaugio': model25, 'diemdanhgiaovien': model26, 'diemdanhhocsinh': model27, 'diemdanhmuon': model28, 'diemdanhphuhuynh': model29, 'diemdanhthubay': model30, 'doanhthu': model31, 'doanhthuthuc': model32, 'dondandonve': model33, 'dondanthuoc': model34, 'donvihanhchinh': model35, 'donxinnghi': model36, 'dotdanhgiasuckhoe': model37, 'dungluongalbums': model38, 'forgetPassword': model39, 'formdanhgia': model40, 'giamtru': model41, 'giaovien': model42, 'goithanhtoan': model43, 'hoadon': model44, 'hoatdongchung': model45, 'hoatdongngoaikhoa': model46, 'hocsinh': model47, 'khaibaothongtin': model48, 'khaosat': model49, 'khauphanan': model50, 'khoanchitieu': model51, 'khoanthu': model52, 'kyhoc': model53, 'lamthubay': model54, 'lichhoc': model55, 'lichhocanh': model56, 'lichsuthanhtoan': model57, 'loidancuaphuhuynh': model58, 'loptinchi': model59, 'maudanhgia': model60, 'monhoc': model61, 'monhocclone': model62, 'nhapkho': model63, 'nhapKhoNL': model64, 'quangcao': model65, 'quanlycauhinh': model66, 'quanlydanhgia': model67, 'quanlylop': model68, 'quydoi': model69, 'register': model70, 'sukien': model71, 'taikhoangiaovien': model72, 'taikhoanhieutruong': model73, 'taikhoankhach': model74, 'taikhoanphuhuynh': model75, 'templatelich': model76, 'thanhlytaisan': model77, 'thongbao': model78, 'thongkegiaovien': model79, 'thongkehocsinh': model80, 'thongkeluong': model81, 'thongtinchitiet': model82, 'thongtinhocphi': model83, 'thongtinhocphilop': model84, 'thongtinhocsinh': model85, 'thucdonanh': model86, 'thucdonmau': model87, 'thucdonmauchitiet': model88, 'thucphamkho': model89, 'tienthua': model90, 'tintucmamnon': model91, 'trangthaihocphi': model92, 'trongmuon': model93, 'trongmuonthang': model94, 'truong': model95, 'upload': model96, 'user': model97, 'vaitroquantri': model98, 'xemdsgiaovien': model99, 'xemdshocsinh': model100, 'xemdshocsinhtamnghi': model101, 'xuatbaocaothucpham': model102, 'xuatkho': model103 };

export type Model<T extends keyof typeof models> = {
  [key in keyof typeof models]: ReturnType<typeof models[T]>;
};

export type Models<T extends keyof typeof models> = Model<T>[T]

const dispatcher = new Dispatcher!();
const Exe = Executor!;

export default ({ children }: { children: React.ReactNode }) => {

  return (
    <UmiContext.Provider value={dispatcher}>
      {
        Object.entries(models).map(pair => (
          <Exe key={pair[0]} namespace={pair[0]} hook={pair[1] as any} onUpdate={(val: any) => {
            const [ns] = pair as [keyof typeof models, any];
            dispatcher.data[ns] = val;
            dispatcher.update(ns);
          }} />
        ))
      }
      {children}
    </UmiContext.Provider>
  )
}
